'use client';

import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import { useQuality } from './QualityProvider';

const LenisActive = dynamic(() => import('./LenisActive'), { ssr: false });

// Lenis activates only on mid/high tier. Mobile (low tier by default)
// uses the browser's native scroll — Lenis + iOS Safari momentum scroll
// has a known failure mode where `html.lenis-active body { overflow:
// hidden }` stays active without a transform replacement, locking the
// page. Tying Lenis activation to tier instead of viewport width keeps
// the Lenis gate and the 3D journey gate in perfect sync — both depend
// on the same source of truth, so a user who explicitly forces
// `?tier=high` on mobile gets BOTH the journey AND Lenis (the journey
// hijack needs Lenis to drive ScrollTrigger correctly).
export function LenisGate({ children }: { children: ReactNode }) {
  const { tier } = useQuality();
  const enabled = tier === 'mid' || tier === 'high';

  return (
    <>
      {enabled && <LenisActive />}
      {children}
    </>
  );
}
